import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Services = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Services", "service/service_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.Services || { Main: {} };
  return (
    <div
      className="container-fluid py-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style={{
        visibility: 'visible',
        animationDelay: '0.1s',
        animationName: 'fadeInUp',
      }}
    >
      <div className="container py-5">
        <div
          className="section-title text-center position-relative pb-3 mb-5 mx-auto"
          style={{ maxWidth: '600px' }}
        >
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content1}</h5>
          <h1 className="mb-0">{LANGUAGE.Main.Content2}</h1>
        </div>
        <div className="row g-5">
          <div
            className="col-lg-12 wow zoomIn"
            data-wow-delay="0.3s"
            style={{
              visibility: 'visible',
              animationDelay: '0.3s',
              animationName: 'zoomIn',
            }}
          >
            <p>
              <strong>{LANGUAGE.Main.Content3}</strong>{LANGUAGE.Main.Content4}
            </p>
            <h4 className="fw-bold">{LANGUAGE.Main.Content5}</h4>
            <ul>
              <li>
                <strong>{LANGUAGE.Main.Content6}</strong>{LANGUAGE.Main.Content7}
              </li>
              <li>
                <strong>{LANGUAGE.Main.Content8}</strong>{LANGUAGE.Main.Content9}
              </li>
              <li>
                <strong>{LANGUAGE.Main.Content10}</strong>{LANGUAGE.Main.Content11}
              </li>
              <li>
                <strong>{LANGUAGE.Main.Content12}</strong>{LANGUAGE.Main.Content13}
              </li>
              <li>
                <strong>{LANGUAGE.Main.Content14}</strong>{LANGUAGE.Main.Content15}
              </li>
              <li>
                <strong>{LANGUAGE.Main.Content16}</strong>{LANGUAGE.Main.Content17}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
